<script>
import { h, defineComponent, toRef } from 'vue-demi'

const InputPreview = defineComponent({
  name: 'FPreviewTextInput',
  // eslint-disable-next-line vue/require-prop-types
  props: ['value'],
  setup(props, { attrs, slots }) {
    const value = toRef(props, 'value')
    return () => {
      return h(
        'div',
        {
          class: ['input-readPretty'],
          style: attrs.style,
        },
        [
          slots.prepend &&
            h(
              'span',
              { class: ['input-readPretty__prepend'] },
              slots.prepend({ value: value.value || '' }),
            ),
          h('span', { class: ['input-readPretty__content'] }, [
            // 兼容单位回显
            value && value.value ? `${value.value}${attrs.appendValue || ''}` : 'N/A',
          ]),
          // slots.append &&
          //   h(
          //     'span',
          //     { class: ['input-readPretty__append'] },
          //     slots.append({ value: value.value || '' }),
          //   ),
        ],
      )
    }
  },
})

export default InputPreview
</script>

<style lang="scss">
.input-readPretty {
  min-height: 76px;
  padding-top: 16px;
  padding-bottom: 24px;
  box-sizing: border-box;
  font-size: 28px;
  font-family: DiDiSans-Pro-Medium;
  color: #282b33;
  font-weight: normal;
  vertical-align: top;
  border-bottom: 1px solid #e5e5e5;
  word-break: break-word;
}

.input-readPretty span {
  display: block;
  min-height: 36px;
  line-height: 36px;
}
</style>
